import React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import classes from "./CheckoutCashTypesHeader.module.scss"

const CheckoutCashTypesHeader = props => {
  const {
    total,
    isLinkPay,
    cashTypes,
    setCashTypes,
    multiplePayment,
    setMultiplePayment,
    setFocusedCashType
  } = props

  const [t, i18n] = useTranslation()

  const location = useLocation()

  const handleChange = () => {
    setMultiplePayment(prev => {
      if (!prev) return true

      setCashTypes(prev => {
        const array = [...prev]

        if (array.length <= 1) return prev

        setFocusedCashType(0)

        return [{
          amount: total,
          name: array[0].name,
          value: array[0].value
        }]
      })
    })

    return false
  }

  const isPosPaymentSelected =
    cashTypes.some(cashType => cashType.isTerminal)

  const disabled =
    isLinkPay ||
    isPosPaymentSelected ||
    location.state?.mode === "placeOrder"

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["header"],
        disabled && classes["disabled"]
      )}
    >
      <Checkbox
        disabled={disabled}
        checked={multiplePayment}
        onChange={handleChange}
      />
      <span
        className={clsx(
          classes["headerText"],
          isLtr && classes["headerText-ltr"]
        )}
      >
        {t("پرداخت_چندگانه")}
      </span>
    </div>

  )
}

export default React.memo(CheckoutCashTypesHeader)